import React, {memo} from 'react';
import {Container, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row} from "reactstrap";
import SFXButtonComponent from "./SFXButtonComponent";
import {
    EmailIcon, EmailShareButton,
    WhatsappIcon, WhatsappShareButton,
    FacebookIcon, FacebookShareButton,
    TwitterIcon, TwitterShareButton,
    TelegramIcon, TelegramShareButton,
    LinkedinIcon, LinkedinShareButton,
} from "react-share";


const SocialMediaModalComponent = memo(function ({
                                       isOpen = false,
                                       canCopyUrl = false,
                                       canBeSharedOnFacebook = false,
                                       canBeSharedOnTwitter = false,
                                       canBeSharedOnTelegram = false,
                                       canBeSharedOnWhatsapp = false,
                                       canBeSharedOnLinkedIn = false,
                                       canBeSharedOnEmail = false,
                                       title= "",
                                       url= "",
                                       message = "",
                                       messageTitle = "",
                                       handler
                                   }) {
        const copyTextToClipboard = async () => {
            try {
                await navigator.clipboard.writeText(url)

                console.log('Text copied to clipboard successfully!')
            } catch (error) {
                console.error('Failed to copy text:', error)
            }
        }

        return <Modal isOpen={isOpen}
                   className={'modal-danger modal-sd '}>
                <ModalHeader className="modalHeader">{title}</ModalHeader>
                <ModalBody>
                    {  canCopyUrl &&
                        <div className={".d-flex"}>
                            <div className="input-group w-auto">
                                <Input value={url} readOnly={true} className={".flex-grow-1"}/>
                                <SFXButtonComponent className={".flex-grow-1"}
                                                    color="primary"
                                                    onClick={copyTextToClipboard}
                                >Copy</SFXButtonComponent></div>
                        </div>
                    }
                    <Container className="socialMediaContainer">
                        <Row >
                            <h1 className="m-auto headerText"> Share With </h1>
                        </Row>

                            <div className={".d-flex socialIconGrid"}>
                                {
                                    canBeSharedOnWhatsapp&&<WhatsappShareButton className=".flex-grow-1 socialIcon" url={url}
                                                         title={message}> <WhatsappIcon size={64} round/>
                                        <br/>WhatsApp
                                    </WhatsappShareButton>
                                }
                                {
                                    canBeSharedOnEmail&&<EmailShareButton className=".flex-grow-1 socialIcon" url={url}
                                                      subject={messageTitle} body={message}>
                                        <EmailIcon size={64} round/> <br/>Email
                                    </EmailShareButton>}
                                {
                                    canBeSharedOnFacebook&&<FacebookShareButton className=".flex-grow-1 socialIcon" url={url}
                                                         quote={message}> <FacebookIcon size={64} round/>
                                        <br/>Facebook
                                    </FacebookShareButton>}
                                {
                                    canBeSharedOnTwitter&&<TwitterShareButton className=".flex-grow-1 socialIcon" url={url}
                                                        title={message}> <TwitterIcon size={64} round/> <br/>Twitter
                                    </TwitterShareButton>}
                                {
                                    canBeSharedOnTelegram&&<TelegramShareButton className=".flex-grow-1 socialIcon" url={url}
                                                         title={message + url}> <TelegramIcon
                                        size={64} round/> <br/>Telegram
                                    </TelegramShareButton>}
                                {
                                    canBeSharedOnLinkedIn&&<LinkedinShareButton className=".flex-grow-1 socialIcon" url={url}
                                                         title={message}> <LinkedinIcon size={64} round/>
                                        <br/>LinkedIn
                                    </LinkedinShareButton>}



                            <br></br>
                            </div>

                    </Container>
                </ModalBody>


                <ModalFooter>
                    <SFXButtonComponent color="secondary"
                                        onClick={handler}
                    >Cancel</SFXButtonComponent>
                </ModalFooter>
            </Modal>

    })
export default SocialMediaModalComponent;